import { render, staticRenderFns } from "./CardFormat.vue?vue&type=template&id=396857c6"
import script from "./CardFormat.vue?vue&type=script&lang=js"
export * from "./CardFormat.vue?vue&type=script&lang=js"
import style0 from "./CardFormat.vue?vue&type=style&index=0&id=396857c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports